import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Eye, Lock, Database, ArchiveRestore, UserCheck } from 'lucide-react';

const TomoPrivacy = () => {
  const sections = [
    {
      icon: Database,
      title: 'Information We Collect',
      content: [
        'Task content you create (title, description, metadata)',
        'Usage analytics to improve user experience',
        'Crash reports to enhance app stability'
      ]
    },
    {
      icon: Lock,
      title: 'How We Use Your Information',
      content: [
        'Store your tasks securely on your device or synced storage (if enabled)',
        'Provide search, filtering, and archiving features',
        'Improve app performance and reliability'
      ]
    },
    {
      icon: Shield,
      title: 'Data Protection',
      content: [
        'Industry-standard security practices',
        'No selling of personal data',
        'Data is used strictly for app functionality'
      ]
    },
    {
      icon: Eye,
      title: 'Information Sharing',
      content: [
        'We do not sell or share your personal data with third parties',
        'Anonymous analytics may be collected to improve the app'
      ]
    },
    {
      icon: ArchiveRestore,
      title: 'Task History & Archive',
      content: [
        'Completed tasks are archived for your convenience',
        'You can restore or permanently delete archived tasks at any time'
      ]
    },
    {
      icon: UserCheck,
      title: 'Your Rights',
      content: [
        'Export or delete your data upon request (where applicable)',
        'Control what data the app can access'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-rose-50 pt-20 pb-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-600 rounded-2xl mb-6">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Privacy Policy</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Your privacy matters. Learn how Tomo protects and handles your data.
          </p>
          <div className="mt-6 text-sm text-gray-500">Last updated: Aug 22, 2025</div>
        </motion.div>

        <div className="space-y-6">
          {sections.map((section, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 + index * 0.1 }}
            >
              <div className="flex items-start">
                <div className="flex-shrink-0 w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center mr-6">
                  <section.icon className="w-6 h-6 text-orange-600" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-4">{section.title}</h3>
                  <ul className="space-y-3">
                    {section.content.map((item, idx) => (
                      <li key={idx} className="flex items-start">
                        <div className="w-2 h-2 bg-orange-600 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                        <span className="text-gray-600">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TomoPrivacy; 